import React, { useState, useEffect } from 'react';

const SelectionDropDown = ({ singleProduct, selectArray, setSelectArray }) => {
  const [select, setSelect] = useState({
    value: singleProduct.options[0].value,
    id: singleProduct.options[0].id,
    productId: singleProduct.parentProductId,
  });

  const handleChange = e => {
    let selected = singleProduct.options.find(
      item => item.value === e.target.value
    );
    setSelect({
      value: selected.value,
      id: selected.id,
      productId: singleProduct.parentProductId,
    });
    const index = selectArray.findIndex(
      item => item.productId === singleProduct.parentProductId
    );
    let tempArr = [...selectArray];
    tempArr.splice(index, 1, {
      value: selected.value,
      id: selected.id,
      productId: singleProduct.parentProductId,
    });
    setSelectArray([...tempArr]);
  };

  useEffect(() => {
    setSelectArray(prevArr => [...prevArr, select]);
  }, []);

  return (
    <div className="xrsselect">
      {singleProduct.options.length > 1 ? (
        <select value={select.value} onChange={e => handleChange(e)}>
          {singleProduct.options.map(variantOption => (
            <option
              id={variantOption.id}
              value={variantOption.value}
              key={variantOption.id}
              className="xrs-product__option-text"
            >
              {variantOption.value}
            </option>
          ))}
        </select>
      ) : null}
    </div>
  );
};

export default SelectionDropDown;
